module.exports = __webpack_public_path__ + "img/p2@2x.976cf5df.png";